var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-title-box",style:({marginTop: _vm.marginTop + 'px'})},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"title-line"}),_vm._v(" "),(_vm.url)?_c('router-link',{staticClass:"look-all",attrs:{"to":_vm.url}},[_vm._v("查看全部>")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6e69886","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemTitle.vue
// module id = null
// module chunks = 